var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',_vm._l((_vm.notifications),function(item,index){return _c('Toastr',{key:index,attrs:{"text":item.message,"state":item.state}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }